import { render, staticRenderFns } from "./refund_dialog.vue?vue&type=template&id=036e27f2"
import script from "./refund_dialog.vue?vue&type=script&lang=js"
export * from "./refund_dialog.vue?vue&type=script&lang=js"
import style0 from "./refund_dialog.vue?vue&type=style&index=0&id=036e27f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports